import { Navigate } from "react-router-dom"
import { useActivation } from "@/lib/activation-context"

export function HomeScreen() {
  const { currentStep, complete, isHydrating } = useActivation()
  if (isHydrating) return null

  const target = complete ? "/dashboard" : `/activation/step/${currentStep}`
  return <Navigate to={target} replace />
}
